export default __webpack_public_path__ + "static/media/earthquake.c607ba2c.png";